/* ELT Sydney - Luxury Interactions v4.0 */
(function () {
  'use strict';

  /* ---- SCROLL REVEAL ---- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.shopify-section:not(.header-section):not(#header-group .shopify-section)');
    if (!els.length) return;
    function reveal() {
      var wh = window.innerHeight;
      els.forEach(function(el) {
        if (el.getBoundingClientRect().top < wh * 0.93) el.classList.add('elt-visible');
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { e.target.classList.add('elt-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });
      els.forEach(function(el) { if (!el.classList.contains('elt-visible')) io.observe(el); });
    } else {
      els.forEach(function(el) { el.classList.add('elt-visible'); });
    }
    setTimeout(reveal, 60);
  }

  /* ---- FROSTED HEADER ON SCROLL ---- */
  function initHeader() {
    var h = document.querySelector('header-component') || document.querySelector('.header');
    if (!h) return;
    var was = false;
    window.addEventListener('scroll', function() {
      var is = window.scrollY > 60;
      if (is !== was) {
        was = is;
        if (is) { h.setAttribute('sticky',''); h.classList.add('is-sticky'); }
        else { h.removeAttribute('sticky'); h.classList.remove('is-sticky'); }
      }
    }, { passive: true });
  }

  /* ---- IMAGE FADE ON LOAD ---- */
  function initImageFade() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      if (img.complete) return;
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.6s ease';
      img.addEventListener('load', function() { img.style.opacity = '1'; });
    });
  }

  /* ---- SMOOTH ANCHOR LINKS ---- */
  function initAnchors() {
    document.addEventListener('click', function(e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---- CURSOR MICRO-PARALLAX ON PRODUCT IMAGES ---- */
  function initParallax() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card');
    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        var img = card.querySelector('img');
        if (img) img.style.transform = 'scale(1.06) translate(' + (x * 8) + 'px, ' + (y * 8) + 'px)';
      });
      card.addEventListener('mouseleave', function() {
        var img = card.querySelector('img');
        if (img) img.style.transform = '';
      });
    });
  }

  /* ---- ADD TO CART FEEDBACK ---- */
  function initCartFeedback() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-form__submit, .add-to-cart-button');
      if (!btn) return;
      btn.style.transform = 'scale(0.97)';
      setTimeout(function() { btn.style.transform = ''; }, 150);
    });
  }

  /* ---- TEXT SELECTION — BLACK ---- */
  function initSelection() {
    var style = document.createElement('style');
    style.textContent = '::selection{background:#000!important;color:#fff!important}::-moz-selection{background:#000!important;color:#fff!important}';
    document.head.appendChild(style);
  }

  /* ---- INIT ALL ---- */
  function init() {
    initScrollReveal();
    initHeader();
    initImageFade();
    initAnchors();
    initParallax();
    initCartFeedback();
    initSelection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      document.querySelectorAll('.shopify-section:not(.elt-visible):not(.header-section)').forEach(function(el) {
        el.classList.add('elt-visible');
      });
      initParallax();
    }, 100);
  });

})();
